module.exports = __webpack_public_path__ + "img/1-3.239796de.png";